// eslint-disable-next-line simple-import-sort/imports
import './sass/main.scss';
// need to import logger first to ensure best possible integration
import { logger } from './services/logger';
import { isPublicMode } from './services/publicMode';
// NOTE: app-deps should be imported first in order to inject global libs
import './app-deps';

import angular from 'angular';
import $ from 'jquery';
import moment from 'moment';
import estGlobalsModule from './est/est.globals.module';
import estofficeLegacyModule from './estoffice/estoffice.module';
import appealsModule from './appeals/appeals.module';
import tasksOverviewModule from './tasks.overview/tasks.overview.module';
import workingWithModule from './working.with/working.with.module';
import unitFavoriteBtnModule from './unit-favorite-btn/unitFavoriteBtn.module';
import dashboardModule from './dashboard/dashboard.module';
import svgSectionModule from './svg.section/svg.section.module';
import sectionSvgUploadModule from './section.svg.upload/section.svg.upload.module';
import svgUploadModule from './svg.upload/svg.upload.module';
import ppnPublicModule from './ppn.public/ppn.public.module';
import appealsCounterModule from './appeals.counter/appeals.counter.module';
import contactsCheckerModule from './contacts.checker/contacts.checker.module';
import leadPopupModule from './lead.popup/lead.popup.module';
import unitPopupModule from './unit.popup/unit.popup.module';
import unitInfoPopupModule from './unit.info/unit.info.module';
import leadFormModule from './lead.form/lead.form.module';
import createNewLeadPopupModule from './create.new.lead.popup/create.new.lead.popup.module';
import { setCompileProvider, setRootScope } from './shell/ng';
import { opportunityApi, unitApi } from './services/api';
import sheetsImportModule from './sheets.import/sheets.import.module';
import { initWebpush } from './services/webpush';
import './notifications/NotificationBell.directive';
import './settings/users/MyProfileLink.directive';
import './back.forward.navi/BackForwardNavi.directive';
import leadsModule from './leads/leads.module';

// expose opportunityApi for inline PHP view scripts
window.opportunityApi = opportunityApi;

(function () {
  'use strict';

  if (window.location.hash.includes('#section')) {
    // see js/scripts.js:animateFloorsReveal()
    // when we have #sectionXX anchor we can not use reveal animation
    // because it will create bad visual experience during scroll to bottom
    window.disableFloorRevealAnimation = true;
  }

  /**
   * @typedef {import('./types').RootScope} RootScope
   */

  angular
    .module('estoffice', [
      estGlobalsModule.name,
      estofficeLegacyModule.name,
      'ui.router',
      'angucomplete-alt',
      'ui.bootstrap',
      'ui.bootstrap.collapse',
      'ngCookies',
      'ngFileUpload',
      'isteven-multi-select',
      'ngclipboard',
      'estClipboard',
      contactsCheckerModule.name,
      'ui.mask',
      'mgo-mousetrap',
      'duScroll',
      'timer',
      'dndLists',
      'datamatic',
      'ui.utils.masks',

      unitPopupModule.name,
      unitInfoPopupModule.name,
      leadFormModule.name,
      'selectbox',
      dashboardModule.name,
      'dashboard.main',
      'dashboard.lead.working',
      'dashboard.interval',
      'dashboard.project.overview',
      'dashboard.project.alltime',
      'dashboard.stock',
      'dashboard.employee.sales',
      'autofocus',
      tasksOverviewModule.name,
      'datepicker',
      'tooltip',
      leadPopupModule.name,
      leadsModule.name,
      'settings',
      'settings.customization',
      'settings.stacking.plan',
      'settings.popup',
      'gallery.upload',
      'popup',
      'lead.bulk.status',
      createNewLeadPopupModule.name,
      workingWithModule.name,
      unitFavoriteBtnModule.name,
      'mobile.lead.add',
      sheetsImportModule.name,
      'unit.type.change',
      ppnPublicModule.name,
      svgUploadModule.name,
      sectionSvgUploadModule.name,
      svgSectionModule.name,
      appealsModule.name,
      appealsCounterModule.name,
    ])
    .constant('_', window._)
    .constant('initialHash', window.location.hash)
    //.constant('BX24', window.BX24)
    .config(config)
    .run(run);

  config.$inject = [
    '$urlRouterProvider',
    '$stateProvider',
    '$httpProvider',
    '$compileProvider',
  ];

  function config(
    $urlRouterProvider,
    $stateProvider,
    /** @type {angular.IHttpProvider}*/ $httpProvider,
    /** @type {angular.ICompileProvider} */ $compileProvider,
  ) {
    // inject $compileProvider to allow dynamically register React components as directives
    setCompileProvider($compileProvider);

    $stateProvider.state('main', {
      url: '/',
      template: '<ui-view/>',
    });

    $urlRouterProvider.otherwise('/');

    $httpProvider.defaults.withCredentials = true;
    $httpProvider.defaults.headers.common['X-Requested-With'] =
      'XMLHttpRequest';
    $httpProvider.interceptors.push('xsrfTokenInterceptor');
  }

  run.$inject = [
    '$rootScope',
    '$state',
    '$http',
    '$timeout',
    '$window',
    '$mdDialog',
    '$mdToast',
    '$locale',
    '$cookieStore',
    'localStorageService',
    'estClipboard',
    '$translate',
    'i18nService',
    '$location',
    '$anchorScroll',
    '$filter',
    'initialHash',
  ];

  function run(
    /** @type {RootScope} */ $rootScope,
    $state,
    $http,
    $timeout,
    $window,
    /** @type {angular.material.IDialogService} */ $mdDialog,
    $mdToast,
    $locale,
    $cookieStore,
    localStorageService,
    estClipboard,
    $translate,
    /** @type {import('./est/est.i18n.module').I18nService} */ i18nService,
    $location,
    $anchorScroll,
    $filter,
    initialHash,
  ) {
    // we have used to init this with angular directives
    // however it's not reliable because this directives will be executed only
    // when ng compiler will rich them in markup (and they are placed at bottom of page)
    // therefore we initializing this data manually
    $rootScope.user_id =
      /** @type {HTMLInputElement | null} */ (
        document.querySelector('[data-est-user-id]')
      )?.value || '';
    $rootScope.token =
      /** @type {HTMLInputElement | null} */ (
        document.querySelector('[data-est-token]')
      )?.value || '';
    $rootScope.userEmail =
      /** @type {HTMLInputElement | null} */ (
        document.querySelector('[data-est-user-email]')
      )?.value || '';
    $rootScope.user_group =
      /** @type {HTMLInputElement | null} */ (
        document.querySelector('[data-est-user-group]')
      )?.value || '';
    $rootScope.userAvatar =
      /** @type {HTMLInputElement | null} */ (
        document.querySelector('[data-est-user-avatar]')
      )?.value || '';

    scrollToAnchor(initialHash);
    setRootScope($rootScope);

    const stopWatchingUserId = $rootScope.$watch('user_id', () => {
      // init user-dependent services in case we've got user info
      if (!$rootScope.user_id) {
        return;
      }

      stopWatchingUserId();

      logger.setUser({
        id: $rootScope.user_id,
        email: $rootScope.userEmail,
        ip_address: '{{ auto }}',
      });
      initWebpush({ userId: $rootScope.user_id });
    });

    const setCompany = (/** @type {typeof $rootScope.company} */ company) => {
      $rootScope.company = company;
      i18nService.setLocale(company.ui_locale);
      localStorageService.set('companyInfo', company);

      logger.setExtras({
        locale: company.ui_locale,
        company: company.company_slug,
        currency: company.currency,
      });
    };

    const cachedCompany = localStorageService.get('companyInfo');

    if (cachedCompany) {
      setCompany(cachedCompany);
    } else {
      $http
        .get('/api/customization/company/get', {})
        .success(function (data) {
          setCompany(data);
        })
        .error(function (data, status, headers, config) {
          logger.error('Error fetching company data', {
            error: Object.assign(new Error('Error getting company data'), {
              data,
              status,
              headers,
              config,
            }),
          });
        });
    }

    /*        var token = angular.element('.token')[0].value;
        if(localStorageService.cookie.isSupported) {
            //$cookieStore.put('token', token);
            //localStorageService.cookie.set('token',token,7,false);
        }*/

    $locale.NUMBER_FORMATS.GROUP_SEP = ' ';

    let textDoesntTitle = $translate.instant('general.modal.doesnt.work.title');
    let textDoesntMessage = $translate.instant(
      'general.modal.doesnt.work.message',
    );
    let textGotIt = $translate.instant('general.modal.got.it');
    // recheck this feature and remove if i18n not needed
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    let textLeadWasAdded = $translate.instant('toast.lead.was.added');
    $rootScope.$on('$translateChangeSuccess', function () {
      textDoesntTitle = $translate.instant('general.modal.doesnt.work.title');
      textDoesntMessage = $translate.instant(
        'general.modal.doesnt.work.message',
      );
      textGotIt = $translate.instant('general.modal.got.it');
      textLeadWasAdded = $translate.instant('toast.lead.was.added');
    });

    $rootScope.$on(
      '$stateChangeSuccess',
      function (event, toState, toParams, fromState, _fromParams) {
        if (toState.redirectTo) {
          event.preventDefault();
          $state.go(toState.redirectTo, toParams);
        }

        if (
          toState.name === 'unitpopup.view' ||
          toState.name === 'unitinfo.view'
        ) {
          $('.b-house__unit').removeClass('-state-active');
          $(`div[data-unit-id="${toParams.id}"]`).addClass('-state-active');
        }

        // Хак, используемый при открытиии Unit popup и Lead popup на странице Units
        // Необходимо добавить класс -sidebar_expanded для открытия сайдабара
        if (
          (toState.name === 'unitpopup.view' &&
            fromState.name !== 'unitpopup.view') ||
          (toState.name === 'leadpopup.view' &&
            fromState.name !== 'leadpopup.view')
        ) {
          $('.mdl-js-layout').addClass('-sidebar_expanded');
        } else if (
          (fromState.name === 'unitpopup.view' &&
            toState.name !== 'unitpopup.view') ||
          (fromState.name === 'leadpopup.view' &&
            toState.name !== 'leadpopup.view')
        ) {
          $('.mdl-js-layout').removeClass('-sidebar_expanded');
        }

        if (toState.name === 'newlead' && fromState.name === 'newlead.new') {
          document.location.hash = 'mobile';
        }
      },
    );

    $rootScope.$on('unit.status.changed', function (e, change) {
      // Change color on units dashboard
      const element = $(`div[data-unit-id="${change.id}"]`);
      element.removeClass('-type_sold');
      element.removeClass('-type_reservation');
      element.removeClass('-type_available');
      element.removeClass('-type_notinstock');

      switch (change.new_status.type) {
        case unitApi.STATUS_TYPE.CLOSED:
          element.addClass('-type_notinstock');
          break;
        case unitApi.STATUS_TYPE.AVAILABLE:
          element.addClass('-type_available');
          break;
        case unitApi.STATUS_TYPE.BOOKED:
          element.addClass('-type_reservation');
          break;
        case unitApi.STATUS_TYPE.SOLD:
          element.addClass('-type_sold');
          break;
      }
    });

    $rootScope.$on('resale.update', function (e, change) {
      // Change color on units dashboard
      const element = $(`div[data-unit-id="${change.unitId}"]`);

      if (change.resaleState) {
        element.addClass('-type_resale');
      } else {
        element.removeClass('-type_resale');
      }
    });

    $rootScope.$on('unit.update', function (e, change) {
      const element = $(`div[data-unit-id="${change.unitId}"]`);

      element
        .children('.b-houseroom__price')
        .text(
          $filter('number')(
            Number(change.is_price_per_meter) === 1
              ? change.price
              : Math.round((change.price / change.area_total) * 100) / 100,
          ),
        );
      element
        .children('.b-houseroom__cost')
        .text(
          `${$rootScope.getCurrencySymbol(
            change.currency ? change.currency : window.defaultCurrency,
          )} ${$filter('number')(
            Number(change.is_price_per_meter) === 1
              ? Math.round(change.price * change.area_total * 100) / 100
              : change.price,
          )}`,
          0,
        );

      if (Number(change.is_price_per_meter) === 1) {
        element.children('.b-houseroom__price').removeClass('g-text-gray');
      } else {
        element.children('.b-houseroom__price').addClass('g-text-gray');
      }
    });

    $rootScope._ = window._;
    // Overlay and spinner that hides unstyled content
    $rootScope.showFoucSpinner = true;

    $rootScope.scrolledBelow = {};

    $timeout(function () {
      $rootScope.showFoucSpinner = false;
    }, 1000);

    $rootScope.showNavFoucSpinner = true;

    $rootScope.reportDataUpdatedAt = moment().utc().startOf('day').add(7, 'h');

    $rootScope.clipboardOnSuccess = function (e) {
      estClipboard.onSuccess(e);
    };

    $rootScope.clipboardOnError = function (e) {
      estClipboard.onError(e);
    };

    const setHeight = debounce(function () {
      $rootScope.windowHeight = $(window).innerHeight();
    }, 250);

    setHeight();
    window.addEventListener('resize', setHeight);

    const cookieStackSize = localStorageService.get('stackSize');

    if (isPublicMode()) {
      $rootScope.stackSize = 'md';
    } else if (cookieStackSize) {
      $rootScope.stackSize = cookieStackSize;
    } else {
      if ($location.absUrl().indexOf('/house') > 0) {
        $rootScope.stackSize = 'sm';
      } else {
        $rootScope.stackSize = 'lg';
      }
    }

    $rootScope.switchStackSize = function (size) {
      $rootScope.stackSize = size;
      localStorageService.set('stackSize', size);
    };

    $rootScope.toggleViewMainInfo = function (mode) {
      switch (mode) {
        case 'price':
          $rootScope.showNumAsMainInfo = false;
          $rootScope.showPriceInView = true;
          break;
        case 'area':
          $rootScope.showNumAsMainInfo = false;
          $rootScope.showPriceInView = false;
          break;
        case 'num':
          $rootScope.showNumAsMainInfo = true;
          $rootScope.showPriceInView = false;
          break;
        default:
          return false;
      }

      localStorageService.set('viewMainInfo', mode);
    };

    const cookieViewMainInfo = localStorageService.get('viewMainInfo');

    if (cookieViewMainInfo) {
      $rootScope.toggleViewMainInfo(cookieViewMainInfo);
    } else {
      $rootScope.toggleViewMainInfo('area');
    }

    const cookieHideSold = localStorageService.get('hideSold');

    if (cookieHideSold) {
      $rootScope.hideSold = true;
    } else {
      if (isPublicMode()) {
        $rootScope.hideSold = true;
      } else {
        $rootScope.hideSold = false;
      }
    }

    $rootScope.toggleHideSold = function (state) {
      if (state) {
        $rootScope.hideSold = true;
      } else {
        $rootScope.hideSold = false;
      }

      localStorageService.set('hideSold', state);
    };

    const cookieNaviMode = localStorageService.get('stackingPlanNaviMode');

    if ($location.absUrl().indexOf('/house') > 0) {
      $rootScope.naviMode = 'byHouse';
    } else if (isPublicMode()) {
      $rootScope.naviMode = 'bySection';
    } else if (cookieNaviMode) {
      $rootScope.naviMode = cookieNaviMode;

      const isSectionProduction = !!angular.element('#activeHouseId').length;

      if (cookieNaviMode === 'byHouse' && isSectionProduction) {
        $window.location.href = `/house/${angular.element('#activeHouseId')[0].value}`;
      }
    } else {
      $rootScope.naviMode = 'bySection';
    }

    $rootScope.imageDPR = function () {
      if ($('html').hasClass('hidpi')) {
        return '2.0';
      }

      return '1.0';
    };

    $rootScope.scrollToTop = function () {
      const scrollContainer = document.getElementById('b-scroll-container');
      scrollContainer.scrollTop = 0;
    };

    $rootScope.showNotReadyDialog = function () {
      $mdDialog.show(
        $mdDialog
          .alert()
          .clickOutsideToClose(true)
          .title(textDoesntTitle)
          .textContent(textDoesntMessage)
          .ariaLabel('Alert Dialog')
          .ok(textGotIt),
      );
    };

    $rootScope.copyLeadToClipboard = function (lead, forbidRefresh = false) {
      localStorageService.set('lead', lead);

      if (forbidRefresh) {
        $rootScope.$broadcast('new.ls.lead');
      } else {
        $timeout(function () {
          $window.location.href = '/';
        }, 300);
      }
    };

    $rootScope.redirectToLead = function (leadId) {
      const [, baseRoute] = $location.path().split('/');

      // проверить не находимся ли на странице лидов
      if (['leads', 'tasks', 'appeals'].includes(baseRoute)) {
        $state.go(`${baseRoute}.leadpopup`, { id: leadId });
      } else {
        $state.go('leadpopup.view', { id: leadId });
      }

      return false;
    };

    $rootScope.openPathInIntergation = function (pathType, _estLead) {
      switch (pathType) {
        case 'deal':
          // eslint-disable-next-line no-console
          console.log('deal');
          window.BX24.canUse();
          window.BX24.init(function () {
            window.BX24.openPath('/crm/deal/details/1/', function (result) {
              // eslint-disable-next-line no-console
              console.log(result);
            });
          });
          break;
        case 'contact':
          // eslint-disable-next-line no-console
          console.log('contact');
          window.BX24.canUse();
          window.BX24.openPath('/crm/contact/details/1/', function (result) {
            // eslint-disable-next-line no-console
            console.log(result);
          });
          break;
        default:
          return false;
      }
    };

    $rootScope.getDefaultCountry = function () {
      const countryMap = {
        1: 'UA',
        2: 'RU',
        3: 'BY',
        4: 'VN',
        5: 'KZ',
      };

      return countryMap[$rootScope.company.country_id] || 'UA';
    };

    $rootScope._isNotMobile = (function () {
      let check = false;

      (function (a) {
        if (
          /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(
            a,
          ) ||
          /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw-(n|u)|c55\/|capi|ccwa|cdm-|cell|chtm|cldc|cmd-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc-s|devi|dica|dmob|do(c|p)o|ds(12|-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(-|_)|g1 u|g560|gene|gf-5|g-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd-(m|p|t)|hei-|hi(pt|ta)|hp( i|ip)|hs-c|ht(c(-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i-(20|go|ma)|i230|iac( |-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|-[a-w])|libw|lynx|m1-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|-([1-8]|c))|phil|pire|pl(ay|uc)|pn-2|po(ck|rt|se)|prox|psio|pt-g|qa-a|qc(07|12|21|32|60|-[2-7]|i-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h-|oo|p-)|sdk\/|se(c(-|0|1)|47|mc|nd|ri)|sgh-|shar|sie(-|m)|sk-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h-|v-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl-|tdg-|tel(i|m)|tim-|t-mo|to(pl|sh)|ts(70|m-|m3|m5)|tx-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas-|your|zeto|zte-/i.test(
            a.substr(0, 4),
          )
        ) {
          check = true;
        }
      })(navigator.userAgent || navigator.vendor || window.opera);

      return !check;
    })();

    $rootScope.defineAdditionalCurrency = function (
      countryId,
      currencyDefault,
    ) {
      const currenciesUkraine = ['USD', 'UAH'];
      const currenciesRussia = ['USD', 'RUB'];
      const currenciesBelarus = ['USD', 'BYN'];
      const currenciesVietnam = ['USD', 'VND'];
      const currenciesKazakhstan = ['USD', 'KZT'];
      const currenciesKyrgyzstan = ['USD', 'KGS'];
      // By countries.id. A copy lives in Company::COUNTRY_CURRENCIES (application/models/Company.php)
      const currencyMap = {
        1: currenciesUkraine,
        2: currenciesRussia,
        3: currenciesBelarus,
        4: currenciesVietnam,
        5: currenciesKazakhstan,
        6: currenciesKyrgyzstan,
      };

      const sourceCurrencies = currencyMap[countryId] || [];
      const index = sourceCurrencies.indexOf(currencyDefault);

      if (index > -1) {
        sourceCurrencies.splice(index, 1);
      }

      return sourceCurrencies[0];
    };

    $rootScope.embeddedIntegrationName = null;
    // check if there is an embeddedIntegration, whether it is bitrix24 or amocrm
    // TODO @Konstantin
    //$rootScope.embeddedIntegrationName = "bitrix24";
  }

  angular.module('estoffice').factory('xsrfTokenInterceptor', [
    '$rootScope',
    function (/** @type {RootScope} */ $rootScope) {
      return {
        request(config) {
          if (/^(http|\/\/)/.test(config.url)) {
            // do not add xsrf header for requests to external sites
            // do not send credentials to external sites to allow CORS
            config.withCredentials = false;

            return config;
          }

          const { token } = $rootScope;

          if (
            config.method !== 'GET' &&
            config.data &&
            typeof config.data !== 'string'
          ) {
            config.data.token = token;

            if (!token) {
              logger.error('Can not locate CSRF token');
            }
          }

          if (
            config.method === 'GET' &&
            typeof config.headers['X-Requested-With'] !== 'undefined'
          ) {
            config.headers['X-XSRF-TOKEN'] = token;
          }

          config.headers['X-XSRF-TOKEN'] = token;

          return config;
        },
      };
    },
  ]);

  angular
    .module('estoffice')
    .factory('$exceptionHandler', () => (error, cause) => {
      // forward all ng errors to our logging backend
      logger.error(`Ng error${error.message ? `: ${error.message}` : ''}`, {
        error,
        cause,
      });
    });

  angular.module('estoffice').directive('estSectionId', [
    '$rootScope',
    function ($rootScope) {
      return {
        scope: {
          sectionId: '@estSectionId',
        },
        link(scope, _element, _attrs) {
          $rootScope.sectionId = scope.sectionId;
        },
      };
    },
  ]);

  angular.module('estoffice').directive('scroll', [
    '$rootScope',
    function ($rootScope) {
      return {
        link(scope, element, _attrs) {
          element.bind('scroll', function () {
            const breakpoints = [150, 240, 500];

            breakpoints.forEach(function (i) {
              $rootScope.scrolledBelow[i] = element[0].scrollTop > i;
            });
            scope.$apply();
          });
        },
      };
    },
  ]);

  angular.module('estoffice').directive('restrictInput', function () {
    return {
      restrict: 'A',
      require: 'ngModel',
      link(scope, element, attr, ctrl) {
        ctrl.$parsers.unshift(function (viewValue) {
          const options = scope.$eval(attr.restrictInput);

          if (!options.regex && options.type) {
            switch (options.type) {
              case 'digitsOnly':
                options.regex = '^[0-9]*$';
                break;
              case 'lettersOnly':
                options.regex = '^[a-zA-Z]*$';
                break;
              case 'lowercaseLettersOnly':
                options.regex = '^[a-z]*$';
                break;
              case 'uppercaseLettersOnly':
                options.regex = '^[A-Z]*$';
                break;
              case 'lettersAndDigitsOnly':
                options.regex = '^[a-zA-Z0-9]*$';
                break;
              case 'validPhoneCharsOnly':
                options.regex = '^[0-9 ()/-]*$';
                break;
              default:
                options.regex = '';
            }
          }

          const reg = new RegExp(options.regex);

          if (reg.test(viewValue)) {
            //if valid view value, return it
            return viewValue;
          }

          //if not valid view value, use the model value (or empty string if that's also invalid)
          const overrideValue = reg.test(ctrl.$modelValue)
            ? ctrl.$modelValue
            : '';

          element.val(overrideValue);

          return overrideValue;
        });
      },
    };
  });

  angular.module('estoffice').directive('imageonload', function () {
    return {
      restrict: 'A',
      link(scope, element, attrs) {
        element.bind('load', function () {
          //call the function that was passed
          scope.$apply(attrs.imageonload);
        });
      },
    };
  });

  angular.module('estoffice').directive('iframeOnload', [
    function () {
      return {
        scope: {
          callBack: '&iframeOnload',
        },
        link(scope, element, _attrs) {
          element.on('load', function () {
            return scope.callBack();
          });
        },
      };
    },
  ]);

  angular.module('estoffice').directive('tooltipFollowCursor', function () {
    return {
      restrict: 'A',
      link(scope, element, _attrs) {
        let x;
        let y;

        element.on('mousemove', function (event) {
          x = event.pageX;
          y = event.pageY;
          this.children[0].style.top = `${y + 15}px`;
          this.children[0].style.left = `${x + 15}px`;
        });
      },
    };
  });

  function debounce(func, wait, immediate) {
    let timeout;

    return function (...args) {
      const context = this;

      const later = function () {
        timeout = null;

        if (!immediate) {
          func.apply(context, args);
        }
      };

      const callNow = immediate && !timeout;

      clearTimeout(timeout);
      timeout = setTimeout(later, wait);

      if (callNow) {
        func.apply(context, args);
      }
    };
  }

  function scrollToAnchor(anchor) {
    if (!/#\/?[^/]/.test(anchor)) {
      // if anchor is empty — skip
      return;
    }

    // try to scroll to anchor
    const targetId = anchor.replace(/^#\/?/, '');
    // ui router may add `/` to the hash and it is needed for anchor to work
    // so we will check both ids: with and without leading /
    const target =
      document.getElementById(targetId) ||
      document.getElementById(`/${targetId}`);
    const scrollContainer =
      document.getElementById('b-scroll-container') || document.body;

    if (!target) {
      return;
    }

    let pollsTotal = 0;
    const poll = () => {
      if (pollsTotal > 10) {
        // give up
        return;
      }

      pollsTotal++;

      window.requestAnimationFrame(() => {
        if (angular.element(target).height()) {
          const rect = target.getBoundingClientRect();

          if (rect.y < 300) {
            // do not scroll to anchor if it almost at the top of page
            // this is a workaround to fix scroll-margin-top which is buggy
            // when the target element near the top of page
            // we are using scroll-margin-top to compensate sticky elements
            // on house grid page
            return;
          }

          // we will re-check till scrollTop will become positive
          const shouldRecheck = scrollContainer.scrollTop === 0;

          target.scrollIntoView();

          if (!shouldRecheck) {
            return;
          }
        }

        setTimeout(poll, 500);
      });
    };

    // poll till ng-cloak will be removed and everything is rendered
    poll();
  }
})();
